export const THANKS_MESSAGES_TYPES = {
  NOT_MESSAGE: 1,
  MESSAGE_BY_ORDER: 2,
  COMMON_MESSAGE: 3,
};
